import {Pipe, PipeTransform} from "@angular/core";
import {ConventionalInfoDataType} from "src/enums/conventionalinfodatatype.enum";
@Pipe({
    name: "conventionalInfoDataType",
    standalone: false
})
export class ConventionalInfoDataTypePipe implements PipeTransform {
    constructor() { }

    transform(value?: number): string | void {
        if (typeof value === 'undefined' || value < 0) return;

        return ConventionalInfoDataType[value];
    }
}